import React from 'react';
import { useTranslation } from 'react-i18next';
import { DollarSign, Loader2, Send } from 'lucide-react';
import { formatPrice } from '../../utils/helpers';

const ChatComposer = ({
  chatText,
  onChatTextChange,
  bidAmount,
  onBidAmountChange,
  onSendText,
  onSubmitOffer,
  isSending,
  isPlacingBid,
  showOfferRow,
  listPrice,
  offerInputRef,
  disabled,
}) => {
  const { t } = useTranslation(['conversations', 'bids']);

  const presets = [];
  if (listPrice > 0) {
    presets.push(
      { key: 'p85', label: '−15%', value: Math.round(listPrice * 0.85 * 100) / 100 },
      { key: 'p90', label: '−10%', value: Math.round(listPrice * 0.9 * 100) / 100 },
      { key: 'p100', label: t('listPrice', { defaultValue: 'List' }), value: listPrice }
    );
  }

  const applyPreset = (value) => {
    onBidAmountChange(String(value));
    offerInputRef?.current?.focus({ preventScroll: true });
  };

  return (
    <div className="mp-composer">
      <form
        className="mp-composer__row"
        onSubmit={(e) => {
          e.preventDefault();
          onSendText();
        }}
      >
        <input
          type="text"
          className="mp-composer__input"
          placeholder={t('typeMessage', { defaultValue: 'Type a message...', ns: 'bids' })}
          value={chatText}
          onChange={(e) => onChatTextChange(e.target.value)}
          disabled={disabled || isSending}
        />
        <button
          type="submit"
          className="mp-composer__send"
          disabled={disabled || isSending || !chatText.trim()}
          aria-label={t('send', { defaultValue: 'Send', ns: 'bids' })}
        >
          {isSending ? <Loader2 size={20} className="spin" /> : <Send size={20} />}
        </button>
      </form>

      {showOfferRow && (
        <>
          {presets.length > 0 && (
            <div className="mp-composer__presets">
              {presets.map((p) => (
                <button
                  key={p.key}
                  type="button"
                  className="mp-composer__preset"
                  disabled={disabled || isPlacingBid}
                  onClick={() => applyPreset(p.value)}
                >
                  {p.label}
                  <span>{formatPrice(p.value)}</span>
                </button>
              ))}
            </div>
          )}
          <form
            className="mp-composer__row mp-composer__row--offer"
            onSubmit={(e) => {
              e.preventDefault();
              onSubmitOffer();
            }}
          >
            <input
              ref={offerInputRef}
              type="number"
              className="mp-composer__input mp-composer__input--offer"
              placeholder={t('typeAmount', { ns: 'bids' })}
              value={bidAmount}
              onChange={(e) => onBidAmountChange(e.target.value)}
              disabled={disabled || isPlacingBid}
              step="0.01"
              min="0"
            />
            <button
              type="submit"
              className="mp-composer__send mp-composer__send--offer"
              disabled={disabled || isPlacingBid || !bidAmount}
              aria-label={t('makeOffer', { defaultValue: 'Make offer', ns: 'bids' })}
            >
              {isPlacingBid ? (
                <Loader2 size={20} className="spin" />
              ) : (
                <DollarSign size={20} />
              )}
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default ChatComposer;
